<sim-basic-material-dialog
	(closeClicked)="closeDialog()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-clapperboard-play', fontSet: 'fad'}"
	[headerText]="T.SCENARIO_CREATE_AUTOMATIC_RECORDING_SESSION | translate"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
>
	<ng-container dialogContent>
		<sim-component-loading-container [isLoading]="store.isLoading()" [showBackDrop]="true" loadingIcon="fad fa-cube" />
		<mat-stepper #sessionStepper [linear]="true" labelPosition="bottom" orientation="horizontal">
			@if (!store.isLoading()) {
				<ng-template matStepperIcon="edit">
					<mat-icon fontIcon="fa-check" fontSet="fal" inline />
				</ng-template>

				<!--STEP 1-->
				<mat-step
					[completed]="store.metadataForm.valid && store.stationForms.length > 0 && store.stationForms.valid"
					[editable]="true"
				>
					<ng-template matStepLabel>
						{{ T.CREATE_SESSION_DIALOG_METADATA_AND_STATIONS | translate }}
					</ng-template>

					<ng-template matStepContent>
						<sim-automatic-recording-session-step1 [eventStartDate]="data.eventStartDate" [eventEndDate]="data.eventEndDate" />
					</ng-template>
				</mat-step>

				<!--STEP 2-->
				<mat-step [editable]="true">
					<ng-template matStepLabel>
						{{ T.CREATE_SESSION_DIALOG_PP_SCHEDULE | translate }}
					</ng-template>
					<ng-template matStepContent>
						<sim-automatic-recording-session-step2 />
					</ng-template>
				</mat-step>
			}
		</mat-stepper>
	</ng-container>

	<ng-container actions>
		<!--AUTOSAVE-->
		<sim-autosave-widget
			[promise]="store.autosaveConfig().promise"
			[timestamp]="store.session()?.lastUpdateTime"
			[warningMessage]="null"
		/>

		<!--NAV BUTTONS-->
		@if (sessionStepper?.selectedIndex !== 1) {
			<sim-button
				(onClick)="sessionStepper.next()"
				[disabled]="!sessionStepper.selected?.completed"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-step-forward'}"
				[label]="T.BUTTON_NEXT"
				color="accent"
			/>
		} @else {
			<sim-button
				(onClick)="closeDialog()"
				[disabled]="store.scheduleForm.invalid || store.metadataForm.invalid"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
				[label]="T.BUTTON_FINISH"
				color="accent"
			/>
		}
	</ng-container>
</sim-basic-material-dialog>
